import Config from "../utils/Config";
import axios from "axios";

//* Helper function to handle API error responses
const handleApiError = (error, defaultMessage = "An error occurred") => {
  let errorMessage = defaultMessage;
  let validationErrors = null;

  if (error.response) {
    if (error.response.status === 422) {
      if (error.response.data?.errors) {
        validationErrors = error.response.data.errors;
        const errorFields = Object.keys(error.response.data.errors);
        if (errorFields.length === 1) {
          errorMessage = error.response.data.errors[errorFields[0]][0];
        } else {
          errorMessage = `${
            error.response.data.errors[errorFields[0]][0]
          } (and ${errorFields.length - 1} more error${
            errorFields.length > 2 ? "s" : ""
          })`;
        }
      } else if (error.response.data?.message) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = "Validation error. Please check your input.";
      }
    } else if (error.response.data?.data?.reason) {
      errorMessage = error.response.data.data.reason;
    } else if (error.response.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.response.data?.error) {
      errorMessage = error.response.data.error;
    } else if (error.response.status === 409) {
      errorMessage = "User already exists with this email or phone number.";
    } else if (error.response.status === 500) {
      errorMessage = "Server error. Please try again later.";
    }
  } else if (error.request) {
    errorMessage = "Network error. Please check your connection.";
  } else {
    errorMessage = error.message || "An unexpected error occurred";
  }

  return {
    status: false,
    message: errorMessage,
    validationErrors: validationErrors,
    data: null,
  };
};

class SettingsService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_tk")}`,
      },
    };
  }

  async updateProfile(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/provider/update/profile`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Profile updated successfully!",
        data: response.data,
      };
    } catch (error) {
      return handleApiError(error, "An error occurred while updating profile");
    }
  }

  async changePassword(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/provider/change/password`,
        {
          old_password: payload.old_password,
          password: payload.password,
          password_confirmation: payload.password_confirmation,
        },
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Password changed successfully!",
        data: response.data,
      };
    } catch (error) {
      return handleApiError(error, "An error occurred while changing password");
    }
  }
}

const settingsService = new SettingsService();
export default settingsService;
